<h2 mat-dialog-title [ngClass]="titleClass">
    {{ data.title || 'Message' }}
</h2>
<mat-dialog-content>
    <div class="message-content" [ngClass]="contentClass">
        <div class="message-text">
            {{ data.message }}
        </div>
        @if (data.link) {
            <div class="message-link" style="margin-top: 12px;">
                <a [href]="data.link" target="_blank" rel="noopener noreferrer">Open Azure DevOps work item</a>
            </div>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (data.confirmMode) {
        <button class="btn btn-secondary no-arrow" style="margin-right: 8px;" (click)="onClose()">Cancel</button>
        <button [class]="confirmButtonClass" (click)="onConfirm()">{{ data.confirmLabel || 'Confirm' }}</button>
    } @else {
        <button class="btn no-arrow" (click)="onClose()">Close</button>
    }
</mat-dialog-actions>
